module.exports = __webpack_public_path__ + "static/media/bg-3.bf01b3dc.png";